import { render, staticRenderFns } from "./LegacyRedirect.vue?vue&type=template&id=b0599e24&scoped=true"
import script from "./LegacyRedirect.vue?vue&type=script&lang=ts"
export * from "./LegacyRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0599e24",
  null
  
)

export default component.exports